import { ColorMode } from './types/ColorMode';
var colorMode = ColorMode.LIGHT;
export var setColorMode = function setColorMode(mode) {
  colorMode = mode;
};
export var getColorMode = function getColorMode() {
  return colorMode;
};